import { Button, Space } from 'antd';
import { FC } from 'react';
import styled from 'styled-components';

const TOTAL_STEPS = 4;

interface MarketplaceStepFooterProps {
  isEditing: boolean;
  isPublished: boolean;
  currentStep: number;
  onSaveDraft: () => Promise<void>;
  onPublishChanges: () => Promise<void>;
  onNext: () => void;
  publishActionLabel: string;
  isPrimaryActionDisabled?: boolean;
  isLoading?: boolean;
}

export const MarketplaceStepFooter: FC<MarketplaceStepFooterProps> = ({
  isEditing,
  isPublished,
  currentStep,
  onSaveDraft,
  onPublishChanges,
  onNext,
  publishActionLabel,
  isPrimaryActionDisabled,
  isLoading,
}) => {
  const isLastStep = currentStep === TOTAL_STEPS - 1;

  return (
    <FooterWrapper>
      <Space>
        {!isEditing && (
          <>
            <Button type='primary' loading={isLoading} onClick={onSaveDraft}>
              Criar Rascunho
            </Button>
            {!isLastStep && (
              <Button loading={isLoading} onClick={onNext}>
                Próximo
              </Button>
            )}
          </>
        )}

        {isEditing && !isPublished && (
          <>
            <Button loading={isLoading} onClick={onSaveDraft}>
              Salvar Rascunho
            </Button>
            <Button
              type='primary'
              loading={isLoading}
              disabled={isLastStep ? isPrimaryActionDisabled : false}
              onClick={isLastStep ? onPublishChanges : onNext}
            >
              {isLastStep ? publishActionLabel : 'Próximo'}
            </Button>
          </>
        )}

        {isEditing && isPublished && (
          <Button
            type='primary'
            loading={isLoading}
            disabled={isPrimaryActionDisabled}
            onClick={onPublishChanges}
          >
            Publicar Alterações
          </Button>
        )}
      </Space>
    </FooterWrapper>
  );
};

const FooterWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 48px;
  right: 0;
  z-index: 100;
  display: flex;
  justify-content: flex-end;
  padding: 12px 32px 12px 80px;
  background: #141414;
  border-top: 1px solid #383838;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.25);
`;
